import * as React from 'react';
import type { DragDropContextProps, DraggableProps, DroppableProps } from 'react-beautiful-dnd';
import {
    DragDropContext as RDragDropContext,
    Draggable as RDraggable,
    Droppable as RDroppable,
} from 'react-beautiful-dnd';

/**
 * react-beautiful-dnd 类组件与 React 18 @types/react 的 JSX 校验不兼容（TS2786），
 * 断言为 ComponentType 后类型与运行时行为不变。
 */
export const DragDropContext = RDragDropContext as unknown as React.ComponentType<DragDropContextProps>;
export const Droppable = RDroppable as unknown as React.ComponentType<DroppableProps>;
export const Draggable = RDraggable as unknown as React.ComponentType<DraggableProps>;

export type { DropResult } from 'react-beautiful-dnd';
